<template>
  <v-container id="docForm" style="max-width: 1500px">
    <!-- first card -->
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <span
              style="font-weight: bold; font-size: 16px"
              >Order No: {{DocNum}}</span
            >
          </v-col>

          <v-col cols="3">
            <span
              style="font-weight: bold; font-size: 16px"
              >Date: {{ date }}</span
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of first card -->

    <!-- second card -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense id="po" class="text--primary subtitle-2">
          <v-col cols="12">
            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="posHeaders"
              :items="cart"
              item-key="LineNum"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.Name="{ item }">
                <div style="width: 300px">{{item.Name}}</div>
              </template>


              <template v-slot:item.Quantity="{ item }">
                <div style="width: 100px">{{item.Quantity}}</div>
              </template>

              <template v-slot:item.Price="{ item }">
                <div style="width: 100px">{{item.Price.toLocaleString()}}</div>
              </template>


              <template v-slot:item.LineTotal="{ item }">
                <div style="width: 100px">{{item.LineTotal.toLocaleString()}}</div>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>

          <v-col cols="12" class="mt-2">
            <span style="font-size: 20px; color: blue; float: right; margin-right: 20px" v-if="(totalAmount > 0)">Total: {{totalAmount.toLocaleString()}}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- third card -->

    <v-row class="mt-2">
      <v-col cols="12">
        <v-btn color="accent" class="right" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Create Order
        </v-btn>
      </v-col>
    </v-row>
    <!-- end of card -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { http } from "@/common/index";
import { mapGetters } from "vuex";
export default {
  components: {
  },
  props: {
    docCreate: {
      type: Boolean,
    },
    loaderOff: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    printing: true,
    customerDialog: false,
    outsourcedDialog: false,
    currentCustomerBalance: null,
    select: "",
    selectDesc: "",
    searchProducts: null,
    isLoading: false,
    outItem: {},
    accountItem: {},
    customerItem: {},
    accountDialog: false,
    enableCreate: true,
    searchingProduct: false,
    UserSign: null,
    enablePriceList: "N",
    showStockHint: true,
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    changeCash: 0,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    outArray: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10),
    smsRef: "",
    clearDate: "",
    dateReadonly: "N",
    AccountVersion: "N",
    posHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Action", value: "action" },
    ]
  }),
  computed: {
    ...mapGetters(["cart"]),
    role() {
      return localStorage.getItem("userRole");
    },
    cardcode() {
      return localStorage.getItem("cardcode");
    },
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.cart != "undefined" && this.cart.length > 0) {
        return this.cart
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map((item) => {
            const amount = parseFloat(item.SumApplied);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAfterDisc;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const balance = this.totalAmount - parseFloat(sum) - parseFloat(disc);
      return balance;
    },
    totalAfterDisc() {
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const total = this.totalAmount + this.outTotalAmount - parseFloat(disc);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    displayBalance() {
      return this.balance.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    outsourcedProfit() {
      let qty = 0;
      let buyingPrice = 0;
      let sellingPrice = 0;
      let profit = 0;

      qty = this.outItem.Quantity;
      buyingPrice = this.outItem.BuyingPrice;
      sellingPrice = this.outItem.Price;

      profit = qty * sellingPrice - qty * buyingPrice;

      return profit;
    },
    outTotalAmount() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  watch: {
    stores: {
      handler: "setDriver",
      immediate: true,
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    querySelections(searchText) {
      const self = this;
      // const existingProduct = this.orderItems.find((record) => {
      //   return record.BarCode == searchText;
      // });

      // if (existingProduct) {
      //   const pos = this.orderItems.indexOf(existingProduct);

      //   const newQty = existingProduct.Quantity + 1;
      //   existingProduct.Quantity = newQty;

      //   this.orderItems[pos] = existingProduct;

      //   this.select = "";
      // }

      // if (!existingProduct) {
      const url = "/search-products";
      const data = {
        searchText: searchText,
      };
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            // if (res.ResponseData.length == 1) {
            //   const product = res.ResponseData[0];
            //   if (product.BarCode != null) {
            //     self.setOrderItem(product.id);
            //     self.select = "";
            //   }
            // }

            // if (res.ResponseData.length != 1) {
            //   self.products = res.ResponseData;
            // }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // }
    },
    setDriver(val) {
      if (val) {
        const store_id = this.activeStore;
        const selectedStore = val.find((record) => {
          return record.id === parseInt(store_id);
        });
        if (selectedStore && selectedStore.driver != undefined) {
          this.record.driver = selectedStore.driver.id;
        }
      }
    },
    setNewDriver() {
      const stores = this.stores;
      const store_id = this.activeStore;
      const selectedStore = stores.find((record) => {
        return record.id === parseInt(store_id);
      });
      if (selectedStore.driver) {
        this.record.driver = selectedStore.driver.id;
      }
    },
    outModal() {
      this.outItem = {};
      this.outsourcedDialog = true;
    },
    customerModal() {
      this.customerDialog = true;
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.record.CardCode = customer.id;
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    changeAmount() {
      let amountPaid = 0;
      let bill = 0;
      bill = this.totalAfterDisc;
      amountPaid = parseFloat(this.AmountGiven);
      const changeValue = amountPaid - bill;
      this.changeCash = changeValue;
    },
    openCreate() {
      this.accountDialog = true;
    },
    qtyOutChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.outItem.LineTotal = LineTotal;
      this.outItem.DisplayTotal = DisplayTotal;
    },
    addOutProduct() {
      if (
        this.outItem.Name == undefined ||
        this.outItem.Quantity == undefined ||
        this.outItem.Price == undefined ||
        this.outItem.Price == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields!", "red");
      } else {
        const self = this;
        const initArray = [];
        self.outItem.LineNum = new Date().getTime();
        self.outItem.Commission = this.outsourcedProfit;
        self.outItem.LineProfit = this.outsourcedProfit;
        const LineTotal =
          parseFloat(this.outItem.Quantity) * parseFloat(this.outItem.Price);
        self.outItem.LineTotal = LineTotal;
        initArray.push(self.outItem);
        self.outArray = [...self.outArray, ...initArray];
        this.outItem = {};
        this.outsourcedDialog = false;
      }
    },
    deleteOutRow(item) {
      const selectedRow = this.outArray.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.outArray.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.outArray.splice(pos, 1);
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      this.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = [...this.accounts, res.ResponseData];
            self.paymentItem.o_a_c_t_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Account Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.accountDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const item = this.paymentItem;
          const account = this.accounts.find((record) => {
            return record.id === accoutId;
          });
          // check if payment mode exist
          const data = {
            o_a_c_t_s_id: account.id,
            account: account.Name,
            SumApplied: item.SumApplied,
            PaymentRemarks: item.PaymentRemarks,
            PaymentPhone: item.PaymentPhone,
          };
          this.payments.push(data);
          this.paymentItem = {};
          this.paymentDialog = false;

          // end of check
        }
      }
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find((record) => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    printWindowsReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;
      const DocDate = data.dataocDate;
      const storeName = this.storeName;

      const outstandingBalance = this.currentCustomerBalance + this.balance;
      // some updates here

      return http.post(
        "http://localhost/stalispos-receipt/src/transactions/PrintPosReceipt.php",
        {
          p_products,
          total_cost,
          DiscSum,
          totalAfterDisc,
          total_payments,
          userName,
          customerName,
          customerBalance,
          receipt_no,
          ref2,
          seller,
          ChangeAmount,
          AmountGiven,
          deliveryAddress,
          deliveryCustomer,
          deliveryPhone,
          totalDelivery,
          outstandingBalance,
          storeName,
          DocDate,
        }
      );
    },
    printReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;

      const outstandingBalance = this.currentCustomerBalance + this.balance;

      return http.post("https://posprinter.local/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        outstandingBalance,
      });
    },
    printCityReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.ref2;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;
      const deliveryLocation = this.record.DeliveryLocation;
      const payments = this.payments;

      const outstandingBalance = this.currentCustomerBalance + this.balance;

      return http.post("https://posprinter.local/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        payments,
        deliveryLocation,
        outstandingBalance,
      });
    },
    printReceiptLocal(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = data.custRef;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      const ChangeAmount = this.changeCash;
      const AmountGiven = this.AmountGiven;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.deliveryCustomer;
      const deliveryPhone = data.deliveryPhone;
      const totalDelivery = data.totalDelivery;
      const outstandingBalance = this.currentCustomerBalance + data.Balance;

      return http.post("http://localhost:3000/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        outstandingBalance,
      });
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      this.$store.commit("removeFromCart", item.id);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      // if (data.Quantity > data.available) {
      //   this.$refs.snackbar.show(
      //     `Your stock is low! current stock ${data.available}`,
      //     "red"
      //   );
      // }

      let Price;
      let Quantity;
      let DiscSum;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.DiscSum) {
        DiscSum = parseFloat(data.DiscSum);
      } else {
        DiscSum = 0;
      }
      const TotalBefTax = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find((record) => {
        return record.id === data.TaxId;
      });
      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * TotalBefTax;
      }
      const TotalAfterTax = TotalBefTax + taxAmount;
      const LineTotal = Math.round(TotalAfterTax - DiscSum);
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find
      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
      // }
    },
    oplnChange(item) {
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      const qData = {
        product_id: item.o_i_t_m_s_id,
        SUoMEntry: item.UomEntry,
        o_p_l_n_s_id: item.o_p_l_n_s_id,
      };
      const url = "/price-calculation";
      const self = this;
      self.$store.dispatch("post", { url, data: qData }).then((res) => {
        currentItem.Price = res.ResponseData.FINALSALESPRICE;
        self.orderItems[pos] = currentItem;
        self.inputChanged(currentItem);
      });
    },
    uomChange(item, ugp1) {
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find((record) => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.SellingPrice;
      this.orderItems[pos] = currentItem;
      this.inputChanged(currentItem);
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};

            const qData = {
              product_id: product.id,
              SUoMEntry: product.SUoMEntry,
              o_p_l_n_s_id: product.itm4[0].o_p_l_n_s_id,
              store_id: store_id,
            };

            // set price list
            currentItem.priceLists = product.itm4;
            currentItem.o_p_l_n_s_id = product.itm4[0].o_p_l_n_s_id;
            currentItem.Quantity = 1;
            currentItem.ManualStatus = product.ugpentry.IsManual;
            currentItem.UomEntry = product.SUoMEntry;
            currentItem.ugp1 = product.ugpentry.ugp1;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            currentItem.PurchaseCurrency = null;
            currentItem.cnvRate = null;
            currentItem.BaseCurrencyTotal = null;
            currentItem.TaxId = null;
            currentItem.TaxRate = null;
            currentItem.BarCode = product.BarCode;
            currentItem.ref1 = null;
            currentItem.TaxAmount = null;
            currentItem.BatchID = null;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];

            // check if manual
            const url = "/price-calculation";
            self.$store.dispatch("post", { url, data: qData }).then((res) => {
              // assign available and buying price
              currentItem.bp =
                res.ResponseData.BuyingPrice || product.BuyingPrice;
              currentItem.BuyingPrice =
                res.ResponseData.BuyingPrice || product.BuyingPrice;
              currentItem.available = res.ResponseData.available;
              // end of bp assign
              if (product.ugpentry.IsManual == "Y") {
                // check if manual yes and assign
                currentItem.Price = res.ResponseData.FINALSALESPRICE;
                currentItem.currentPrice = res.ResponseData.FINALSALESPRICE;
                const total = 1 * parseFloat(res.ResponseData.FINALSALESPRICE);
                currentItem.LineTotal = total;
                currentItem.DisplayTotal = total.toLocaleString();

                initArray.push(currentItem);
                this.orderItems = [...this.orderItems, ...initArray];
                this.select = null;
                // end of manual yes
              }

              // start of manual No status
              if (product.ugpentry.IsManual == "N") {
                let ugp1Data = product.ugpentry.ugp1;
                const ugp1Record = ugp1Data.find((record) => {
                  return record.UomEntry === product.SUoMEntry;
                });
                currentItem.Price = ugp1Record.SellingPrice;
                currentItem.currentPrice = ugp1Record.SellingPrice;
                const total = 1 * ugp1Record.SellingPrice;
                currentItem.LineTotal = total;
                currentItem.DisplayTotal = total.toLocaleString();

                // push to array
                initArray.push(currentItem);
                this.orderItems = [...this.orderItems, ...initArray];
                this.select = "";
                self.products = [];
                // end of push
              }
              // end of manual No status
            });

            // get price api call
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    sendData() {
      if (this.date != null) {
        if (this.SoldBy == "Y" && this.UserSign == null) {
          this.$refs.snackbar.show("Please select the seller", "red");
        } else {
          if (this.cart.length > 0) {
                // get seller
                const sellerId = this.UserSign;
                let seller = {};
                if (sellerId !== null) {
                  seller = this.users.find((record) => {
                    return record.id === sellerId;
                  });
                }
                // end of get
                let saleDate = this.date;
                this.record = { ...this.record, DocDate: saleDate };
                const data = this.record;
                data.rows = this.cart;
                data.outRows = this.outArray;
                data.TargetType = null;
                data.BaseType = null;
                data.BaseEntry = null;
                data.ObjType = 14;
                data.DocTotal = this.totalAmount;
                data.DocNum = this.DocNum;
                data.UserSign = this.UserSign;
                data.ref2 = this.ref2;
                data.seller = seller.name;
                data.TotalPaid = 0;
                data.Balance = this.totalAmount;
              
                data.saleType = "credit";
                data.userName = this.userName;
                data.CardCode = this.cardcode;
                data.DiscSum = 0;
                // set payments
                // const paidAmount = 0;

                data.payments = [];

                // save data
                const url = "/documents";
                const self = this;
                this.loader = true;
                this.$store
                  .dispatch("post", { url, data })
                  .then((res) => {
                    if (res.ResultCode == 1200) {
                      //self.printReceipt(printData);
                      self.getDocNum();
                      const NewDate = this.record.DocDate;
                      self.record = {};
                      self.record.DocDate = NewDate;
                      if (self.clearDate == "Y") {
                        this.$refs.dateRef.clearDate();
                      }
                      self.orderItems = [];
                      self.outArray = [];
                      self.SumApplied = 0;
                      self.payments = [];
                      self.DiscOnTotal = 0;
                      self.ref2 = null;
                      self.UserSign = null;
                      this.$refs.snackbar.show("Sale successful", "green");
                      this.loader = false;
                     // self.setNewDriver();
                      this.$store.commit("resetCart");
                      self.$router.push("/customer/order");
                    } else {
                      this.loader = false;
                      this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                  })
                  .catch((err) => {
                    this.loader = false;
                    this.$refs.snackbar.show(err, "red");
                  });
              
              // balance < 0 curly brace
          
          } else {
            this.$refs.snackbar.show(
              "You must have at least one product",
              "red"
            );
          }
        }
      } else {
        this.$refs.snackbar.show("Please select date!", "red");
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    // getProducts() {
    //   const self = this;
    //   const id = this.activeStore;
    //   this.$store
    //     .dispatch("get", `/stores/${id}`)
    //     .then((res) => {
    //       if (res.ResultCode == 1200) {
    //         self.products = res.ResponseData.itm2;
    //       } else {
    //         this.$refs.snackbar.show(res.msg, "red");
    //       }
    //     })
    //     .catch((err) => {
    //       this.$refs.snackbar.show(err, "red");
    //     });
    // },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.storeId = res.ResponseData.DefaultStockStore;
              self.IMEI = res.ResponseData.IMEI;
              self.SoldBy = res.ResponseData.SoldBy;
              self.smsRef = res.ResponseData.smsRef;
              self.enablePriceList = res.ResponseData.enablePriceList;
              self.clearDate = res.ResponseData.clearDate;
              self.dateReadonly = res.ResponseData.dateReadonly;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: 1,
        Price: null,
        LineTotal: 0,
        TaxId: this.taxGroups[0].id,
        TaxRate: null,
        ref1: null,
        TaxAmount: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DiscSum: null,
        DisplayTotal: 0,
        BatchID: null,
        PurchaseCurrency: null,
        cnvRate: null,
        BaseCurrencyTotal: null,
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    setDefaultRow() {
      const self = this;
      this.$store.dispatch("get", `/taxgroups/O`).then((res) => {
        if (res.ResultCode == 1200) {
          self.taxGroups = res.ResponseData;
          const LineNum = new Date().getTime();
          let initArray = [];
          const details = {
            LineNum: LineNum,
            Name: null,
            Quantity: 1,
            Price: null,
            LineTotal: 0,
            TaxId: res.ResponseData[0].id,
            TaxRate: null,
            ref1: null,
            TaxAmount: null,
            UomEntry: null,
            ManualStatus: null,
            ugp1: [],
            DiscSum: null,
            DisplayTotal: 0,
            BatchID: null,
            PurchaseCurrency: null,
            cnvRate: null,
            BaseCurrencyTotal: null,
          };
          initArray.push(details);
          this.orderItems = [...this.orderItems, ...initArray];
        }
      });
    },
    getDrivers() {
      const self = this;
      this.$store
        .dispatch("get", `/drivers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.drivers = res.ResponseData;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomerBalance(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-customer-balance/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.currentCustomerBalance = res.ResponseData.Balance;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    resetLoader() {
      this.loader = false;
    },
  },
  created() {
    // this.setDefaultRow();
    Promise.all([
      this.getCustomers(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
      this.getAccounts(),
      this.getUsers(),
      this.getDrivers(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>